import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { AuthenticationProviderType } from "@/domain/enums/authentication-provider-type";

export default class LoginForm {
	constructor(public store: IIncentiveV2Store){}

	public async login(): Promise<void> {
		await this.store.actions.login({
			provider: AuthenticationProviderType.DIRECT,
			email: this.store.getters.email() ?? "",
			password: this.store.getters.password() ?? "",
		});
	}
}